import { Button, Typography } from '@breetometer/components';
import { NotificationIcon } from 'BreetAssets';
import { memo, useCallback } from 'react';

import type { IMobileMenuItem } from './SidebarMobile.helpers';

const MenuItem = ({ sideMenuItem, setMobileMenu, onMenuClick }: IMobileMenuItem) => {
	const isNotifications = sideMenuItem.icon && sideMenuItem.menu === 'Notifications';

	const handleMenuClick = useCallback(() => {
		setMobileMenu(onMenuClick(sideMenuItem.url))().catch(console.error);
	}, [sideMenuItem.url, setMobileMenu, onMenuClick]);

	return (
		<Typography
			as='li'
			className='sidemenumobile_menuitem'
			key={sideMenuItem.menu}
		>
			<Button
				variant='native'
				onClick={handleMenuClick}
				className='color-neutral-50'
			>
				{sideMenuItem.menu}
				{isNotifications && (
					<NotificationIcon
						className='menumobileicon svg-notification cursor_pointer'
						variant='new-message'
					/>
				)}
			</Button>
		</Typography>
	);
};

export default memo(MenuItem);
